// import React, { useEffect } from 'react'
// import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom"
// const Logout = () => {
//   const Navigate = useNavigate();
//   const Auth = localStorage.removeItem("token")
//   localStorage.clear();
//   if (Auth) {
//     return Navigate("/")
//   }
// }
// export default Logout;
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axiosConfig from "../Service/axiosConfig"
const Logout = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  useEffect(() => {
    const logoutUser = async () => {
      try {
        await axiosConfig.post("/accounts/api/logout/", {},
          {
            headers: {
              Authorization: `Token ${token}`,
            }
          });
      } catch (error) {
        console.log(error);
      } finally {
        localStorage.clear();
        navigate("/");
      }
    };

    logoutUser();
  }, [navigate]);

  return null;
};

export default Logout;